import { FaBars, FaSync } from "react-icons/fa";
import "../styles/AssignTrips.scss";
import { useNavigate } from "react-router-dom";
import { tripAtom } from "../components/JotaiStates/commonStateAtoms";
import { useSetAtom } from "jotai";
import { alertAtom, globalLoaderAtom } from "../jotaiState/globalStateAtoms";
import { APIAssignedTrips } from "../helper/apiUrls";
import useLogin from "../components/common/useLogin";
import { apiGet } from "../helper/utils";
import { useEffect, useState } from "react";
import RightMenuDrawer from "./RightMenuDrawer";
import dayjs from "dayjs";

const AssignedTrips = () => {
  const setTrip = useSetAtom(tripAtom);
  const setAlert = useSetAtom(alertAtom);
  const setLoader = useSetAtom(globalLoaderAtom);
  const [trips, setTrips] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const { login } = useLogin();
  const navigate = useNavigate();

  const getTrips = () => {
    setLoader(true);
    const payload = {
      intDriverID: login?.DriverID || 0,
    };
    apiGet(APIAssignedTrips, payload)
      .then((res) => {
        if (!res.IsSuccess) {
          throw new Error(res.ErrorMessage || "Error fetching trips");
        }
        const data = JSON.parse(res.Data);
        setTrips(data);
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: "" });
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    getTrips();
  }, []);

  const handleTripClick = (trip) => {
    setTrip(trip);
    navigate("/trip-details");
  };
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };
  return (
    <div className="assigned-trips-container">
      {/* 🔵 Header */}
      <div className="assigned-trips-header">
        <FaBars className="menu-icon" onClick={() => setMenuOpen(true)} />

        <span className="header-title">Assigned Trips</span>

        <FaSync
          className="refresh-icon"
          onClick={getTrips}
        />
      </div>

      {/* Drawer Component */}
      <RightMenuDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        driverName={login?.DriverName}
        onLogout={handleLogout}
      />
      {/* 📦 Page Content */}
      <div className="assigned-trips-content">
        {trips.map((trip, index) => (
          <div
            key={trip.id}
            className="trip-row"
            onClick={() => handleTripClick(trip)}
          >
            <div className="trip-index">{index + 1}.</div>

            <div className="trip-details">
              <div className="trip-route">
                {trip.RouteName}
              </div>

              <div className="trip-info">{dayjs(trip.JourneyDate).format("DD-MMM-YYYY hh:mm A")}</div> 

              <div className="trip-route">{trip.CompanyName}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignedTrips;
